import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AssetService } from 'src/app/shared/services/asset.service';

// Available directions when sorting.
type SortDirection = 'asc' | 'desc';

@Component({
  selector: 'app-sortable-label',
  templateUrl: './sortable-label.component.html',
  styleUrls: ['./sortable-label.component.scss'],
})
export class SortableLabelComponent {
  @Input() enabled = true;
  @Input() class = 'pointer';
  @Input() name: string;
  @Input() current: string;
  @Input() direction: SortDirection;
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() change = new EventEmitter<{ name: string, direction: SortDirection }>();

  constructor(
    public assetService: AssetService,
  ) {}

  onClick() {
    if (!this.enabled) {
      return;
    }

    const defaultValue = this.direction === 'asc'
      ? 'desc'
      : 'asc';

    this.change.emit({
      direction: this.name === this.current
        ? defaultValue
        : 'asc',
      name: this.name,
    });
  }

  getSortIndicatorIcon() {
    return this.assetService.url(
      this.direction === 'asc'
        ? 'indicator-arrow-up'
        : 'indicator-arrow-down',
    );
  }
}
